<template>
  <v-card class="rsu pa-4" style="padding:40px;padding-bottom: 100px;">
    <div style="display: flex; justify-content: space-between; align-items: center">
      <Typography h2 bold :label="$t('เพิ่มสมาชิก')" />
      <v-btn @click="closemodal" icon><v-icon>close</v-icon></v-btn>
    </div>
    <div class="px-3 pb-4">
      <!-- <InputSearch class="mb-3" @clickSearch="onSearch" @clearSearch="clearSearch" :search="search"
        :placeholder="'ค้นหา'" :isSearch="isSearch" :clearAdvancedSearch="clearAdvancedSearch" /> -->

      <v-flex wrap dense style="display: flex; align-items: end; margin-bottom: 10px;">
        <div style="width: 100%; display: flex; align-items: center" class="form-group has-search">
          <span class="fa fa-search form-control-feedback"></span>
          <div style="width: 100%" class="form-control">
            <!-- <input type="search" class="depainput rsu mb-0" :placeholder="placeholder" name="search"
              v-model="search.nameAll" @change="$emit('clickSearch')" /> -->
            <input type="search" class="depainput rsu mb-0" v-model="serachVal"
              :placeholder="'ค้นหา รหัสสมาชิก / ชื่อ - นามสกุล, สถาบัน'" name="search" @change="$emit('clickSearch')" />
          </div>
          <Button search label="ค้นหา" @click="clickSearch" />
        </div>
      </v-flex>
      <div class="form-control" :class="{ 'has-error': errors.has('type') }">
        <Typography h5 semiBold label="ชื่อสมาชิก" :class="`mb-1 ${'dataReq'}`" />
        <multiselect name="สมาชิก" v-validate="'required'" label="label" trackBy="label" :loading="loadingMember"
          :disabled="disabledMember" :options="MembersOptions" v-model="selectedMember" :placeholder="'สมาชิก'"
          :multiple="false">
          <span slot="caret" :slot-scope="{ toggle }" class="arrow">
            <v-icon class="darkBlue" aria-hidden="false" size="24px">
              mdi-chevron-down
            </v-icon>
          </span>
        </multiselect>
        <p class="text-error" v-if="errors.has('โครงการ')">{{ errors.first('โครงการ') }}</p>
      </div>
      <v-flex xs12 class="py-4">
        <div class="form-control" :class="{ 'has-error': errors.has('type') }">
          <Typography h5 semiBold label="โครงการ" :class="`mb-1 ${'dataReq'}`" />
          <multiselect name="โครงการ" label="projectname" trackBy="projectname" :loading="loadingProject"
            :disabled="disabledProject" :options="projectdata" v-model="selectedProject" :placeholder="$t('Project')"
            v-validate="'required'" :multiple="false">
            <span slot="caret" :slot-scope="{ toggle }" class="arrow">
              <v-icon class="darkBlue" aria-hidden="false" size="24px">
                mdi-chevron-down
              </v-icon>
            </span>
          </multiselect>
          <p class="text-error" v-if="errors.has('โครงการ')">{{ errors.first('โครงการ') }}</p>
        </div>
      </v-flex>
      <v-layout class="my-5" justify-center v-if="loading && !showFormInput">
        <v-progress-circular :size="100" :width="10" indeterminate color="primary"></v-progress-circular>
      </v-layout>

      <div xs12 v-if="showFormInput && isDialogOpen">
        <div>
          <div style="padding:20px 52px;border:0px solid #0C2F53;border-radius: 10px 10px 0px 0px;"
            class="color-gradientBlue">
            <div style="color:#fff;font-weight: 700;font-size: 28px;">
              {{ nameForm }}
            </div>
          </div>
          <div>
            <div
              style="display:flex;flex-direction: column;gap:22px;padding:10px;border:1px solid #0C2F53;border-radius: 0px 0px 10px 10px;">
              <div v-if="corditiondp && corditiondate">
                <v-container>
                  <ValidationObserver ref="observer">
                    <div v-for="(item, k) in allform" :key="k + ' ' + currentPage">
                      <FormAddDetail :vid="k + '_' + currentPage" v-model="item.value" :value2.sync="item.value2"
                        :formTable="item.formTable" :OptionsProps="item.Options" :Options2="item.Options2"
                        :cap="RegisterCapital" :paidcap="PaidRegisterCapital" :formdata="item" :shopInfo="shopInfo"
                        :productInfo="productInfo" :showInPage="showInPage" :memberData="memberData"
                        @close="modalPreview = false">
                      </FormAddDetail>
                    </div>
                  </ValidationObserver>
                </v-container>

                <v-flex xs12 class="mb-2 mt-1 center">
                  <v-btn outline v-if="currentPage !== 0" @click="currentPage--" class="rsu customCancelBtn" depressed
                    color="primary"><v-icon>mdi-chevron-left</v-icon>ย้อนกลับ
                  </v-btn>
                  <v-btn outline v-if="currentPage + 1 !== totalPage" @click="nextPage" class="rsu customCancelBtn"
                    depressed color="primary">ถัดไป
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex xs12 class="mb-2 mt-1 center" v-if="totalPage == 1 || totalPage - 1 == currentPage">
                  <v-btn class="rsu customCancelBtn" round outline color="primary" @click="closemodal">
                    {{ formdata.reject ? formdata.reject : '-' }}
                  </v-btn>
                  <v-btn class="rsu customConfirmBtn" round depressed color="primary" @click="saveData">
                    {{ formdata.button ? formdata.button : '-' }}</v-btn>
                </v-flex>
              </div>

              <div v-else>
                <v-layout v-if="!corditiondate" row wrap justify-center>
                  <h4 class="text-center mt-10">โครงการนี้อยู่นอกเวลาการทำการ</h4>
                </v-layout>
                <v-layout v-else-if="!corditiondp" row wrap justify-center>
                  <h4 class="text-center mt-10" v-if="memberData.dptype == 'Non-DP'">
                    ไม่สามารถใช้งานแบบฟอร์มนี้ได้ เนื่องจากผู้กรอกข้อมูลต้องมีสถานะเป็น DP
                  </h4>
                  <h4 class="text-center mt-10" v-else-if="memberData.dptype == 'DP'">
                    ไม่สามารถใช้งานแบบฟอร์มนี้ได้ เนื่องจากผู้กรอกข้อมูลต้องมีสถานะเป็น Non-DP
                  </h4>
                  <h4 class="text-center mt-10" v-else>
                    ไม่สามารถใช้งานแบบฟอร์มนี้ได้ เนื่องจากผู้กรอกข้อมูลต้องมีสถานะไม่ถูกต้อง
                  </h4>
                </v-layout>
              </div>
            </div>
            <vue-element-loading :active="saveForm" spinner="bar-fade-scale" is-full-screen color="#152d51" />
          </div>
        </div>
      </div>
      <div v-if="openModalPayment">
        <PaymentModalProject :sentMemberId="selectedIdMember" :openModalPayment="openModalPayment"
          :applicantid="this.dataPayment.applicantid" @close="openModalPayment = false"></PaymentModalProject>
      </div>
    </div>
    <!-- <v-flex xs12 class="mb-1 mt-5 center">
            <v-btn class="rsu customCancelBtn" @click="closemodal" round outline color="primary">{{ $t('cancel')
            }}</v-btn>
            <v-btn class="rsu customConfirmBtn" :loading="saveloading" @click="saveData" round depressed
                color="primary">{{ $t('Save') }}</v-btn>
        </v-flex> -->
  </v-card>
</template>

<script>
import api from '@/api'
import { store } from '@/store/store'
import moment from 'moment'
import multiselect from 'vue-multiselect'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import Typography from '@/components/elements/Typography.vue'
import DatePicker from 'vue2-datepicker'
import { ToggleButton } from 'vue-js-toggle-button'
import Button from '@/components/elements/Button.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import FormAddDetail from './AddMemberForm/FormAddDetail.vue'
import PaymentModalProject from './AddMemberForm/PaymentModalProject.vue'
import InputSearch from '@/components/elements/InputSearch.vue'

export default {
  components: {
    multiselect,
    DatepickerCustomDialog,
    Typography,
    DatePicker,
    Button,
    ToggleButton,
    ValidationObserver,
    FormAddDetail,
    PaymentModalProject,
  },
  props: {
    isDialogOpen: {
      type: Boolean,
      required: true
    },
    showInPage: {
      default: false
    }
  },
  data() {
    return {
      disabledMember: true,
      disabledProject: true,
      loadingProject: false,
      loadingMember: false,
      selectedProject: [],
      projectdata: [],
      selectedMember: [],
      selectedIdMember: '',
      MembersOptions: [],
      projeceFormDetail: [],
      showFormAddMember: false,
      showFormInput: false,
      nameForm: '',
      formdata: {},
      form: {},
      project: {},
      TypeProjectdata: {},
      memberData: {},
      steps: [],
      shopInfo: {},
      productInfo: {},
      totalPage: 0,
      currentPage: 0,
      formButton: '',
      formReject: '',
      openModalPayment: false,
      dataPayment: {
        applicantfee: 0,
        applicantid: 0
      },
      checkisPadid: false,
      dataPayment: {
        applicantfee: 0,
        applicantid: 0
      },
      serachVal: ''
    }
  },
  watch: {
    isDialogOpen(isOpen) {
      if (isOpen) {
        this.loadingMember = false
        this.disabledMember = true
        this.loadingProject = false
        this.disabledProject = true
        // this.getMembers()
      } else {
        console.log('Dialog is closed in FormAddMember')
      }
    },
    selectedMember(memSelected) {
      this.projectdata = []
      this.selectedProject = null
      if (memSelected) {
        this.selectedIdMember = memSelected.memberid
        this.loadingProject = true
        this.getProjectsData()
      } else {
        console.log('No projects selected.')
      }
    },
    selectedProject(projSelected) {
      if (projSelected && this.projectdata != null) {
        this.getFromData()
      } else {
        this.showFormInput = false
      }
    }
  },
  async mounted() { },
  computed: {
    allform() {
      var result = this.formdata.formitems
      if (result) {
        if (result.some(el => el.questiontype == 'หน้าถัดไป')) {
          var data = []
          var count = 0
          // eslint-disable-next-line no-continue
          result.map((el, index) => {
            if (el.questiontype == 'หน้าถัดไป') {
              count += 1
            } else {
              // eslint-disable-next-line no-continue4
              if (data[count]) {
                data[count].push(el)
              } else {
                data.push([el])
              }
            }
          })
          this.totalPage = data.length
          return data[this.currentPage]
        } else {
          return result
        }
      }
    },
    corditiondp() {
      if (this.projectdata != null) {
        if (!this.foruser.includes('DP') && !this.foruser.includes('Non-DP')) {
          return true
        }
        if (
          // this.currentStepIndex == 0 &&
          this.memberData.dptype &&
          this.foruser.includes(this.memberData.dptype)
        ) {
          return true
          // } else if (this.currentStepIndex > 0) {
          //     return true;
        } else {
          return false
        }
      } else {
        return false
      }
    },
    corditiondate() {
      if (this.project && this.project.showstartdate && this.project.showenddate) {
        let start = this.project.showstartdate
        let end = this.project.showenddate
        let curr = new Date()
        start = new Date(start)
        end = new Date(end)
        curr.setHours(0, 0, 0, 0)
        start.setHours(0, 0, 0, 0)
        end.setHours(0, 0, 0, 0)
        if (curr >= start && curr <= end) {
          this.formButton = this.formdata.button
          this.formReject = this.formdata.reject
          return true
        } else {
          return false
        }
      } else {
        return null
      }
    },
    foruser() {
      return this.project && this.project.foruser ? this.project.foruser.split(',') : []
    },

    dbdData() {
      return this.dbd &&
        this.dbd.data &&
        this.dbd.data.data &&
        this.dbd.data.data.ResultList &&
        this.dbd.data.data.ResultList[0]
        ? this.dbd.data.data.ResultList[0]
        : null
    },
    RegisterCapital() {
      return this.dbd &&
        this.dbd.data &&
        this.dbd.data.data &&
        this.dbd.data.data.ResultList &&
        this.dbd.data.data.ResultList[0] &&
        this.dbd.data.data.ResultList[0].RegisterCapital
        ? this.dbd.data.data.ResultList[0].RegisterCapital
        : null
    },
    PaidRegisterCapital() {
      return this.dbd &&
        this.dbd.data &&
        this.dbd.data.data &&
        this.dbd.data.data.ResultList &&
        this.dbd.data.data.ResultList[0] &&
        this.dbd.data.data.ResultList[0].PaidRegisterCapital
        ? this.dbd.data.data.ResultList[0].PaidRegisterCapital
        : null
    }
  },
  methods: {
    clickSearch() {
      if (this.serachVal !== '' && this.serachVal !== null) {
        this.loadingMember = true
        this.disabledMember = true
        this.loadingProject = false
        this.disabledProject = true
        this.getMembers()
      }

      this.disabledMember = true
      this.disabledProject = true
      this.selectedMember = null
      this.selectedProject = null
      this.selectedIdMember = ''

    },
    async getMembers() {
      let members = await this.getAllUsers(this.serachVal)
      if (members) {
        this.disabledMember = false
        this.loadingMember = false
        this.MembersOptions = members.map(member => ({
          ...member,
          label: member.name || member.institute_name
        }));
      }
    },
    // getMemberLabel(member) {
    //   // ถ้าไม่มีชื่อ ให้ใช้ชื่อบริษัทแทน
    //   return member.name || member.institute_name ;
    // },
    async getProjectsData() {
      const currentTime = new Date().toISOString()
      let project = await api.getProjectsByMember({ memberid: this.selectedIdMember })      
      let memberInfo = await api.checkMemberInfo({ memberid: this.selectedIdMember })
      this.memberData = memberInfo
      this.projectdata = project.filter(
        item => item.publish_status == true && item.projectenddate >= currentTime
      )
      if (this.projectdata) {
        this.loadingProject = false
        this.disabledProject = false
      }
    },
    async getFromData() {
      this.currentPage = 0
      this.formdata = {}

      if (this.memberData && this.memberData.id_card) {
        this.getDBD(this.memberData.id_card)
      }

      const getprojectId = await api.getdepaprojectbyid({ projectid: this.selectedProject.id })
      const getTypedata = JSON.parse(getprojectId.map(item => item.data[0].typedata))
      const getdepaprojectformbyid = await api.getdepaprojectformbyid({
        customform: getTypedata[0].steps[0].customform
      })

      this.nameForm = getdepaprojectformbyid[0].data[0].formname
      this.project = getprojectId[0].data[0]
      this.dataPayment.applicantfee = getprojectId[0].data[0].applicantfee
      this.TypeProjectdata = getTypedata
      this.form = getdepaprojectformbyid[0].data[0]
      this.formdata = JSON.parse(this.form.formdata)
      this.showFormInput = true
    },
    async getDBD(id) {
      let data = await api.getdbdData(id)
      this.dbd = data
    },
    async getShopData(id) {
      let response = await api.getShopData(id, this.memberData.memberid)
      if (response.data.responsecode == 200 && response.data.data.memberid) {
        this.shopInfo = response.data.data
      } else {
        this.shopInfo = {
          memberid: '',
          JuristicID: '',
          RegisterCapital: '',
          PaidRegisterCapital: ''
        }
      }
    },
    closemodal() {
      this.currentPage = 0
      this.formdata = {}
      this.selectedProject = null
      this.selectedMember = []
      this.$emit('close')
    },
    async getAllUsers(searchVal) {
      return new Promise(resolve => {
        var data = {
          pageid: this.selectedBot.pageid,
          //optionalstatus: //optional เช่น confirm, unconfirmedlimit: //optionaloffset: //optional
          chkVerified: true,
          searchVal: searchVal
        }
        api.getdepamember(data, (err, response) => {
          if (response.responsecode == 200) {
            resolve(response.data)
          } else {
            resolve([])
          }
        })
      })
    },
    async nextPage() {
      this.$refs.observer.validate().then(success => {
        if (success) {
          this.currentPage += 1
        } else {
          let el = document.querySelector('.v-input.error--text')
          if (!el) {
            el = document.querySelector('div.error--text')
          }
          el.scrollIntoView()
        }
      })
    },
    async saveData() {
      var isValid = await this.$refs.observer.validate()
      if (isValid) {
        this.$swal
          .fire({
            type: 'question',
            title: '<div class="headline primary--text bold7 fs-24">ยืนยันการทำรายการ?</div>',
            allowOutsideClick: false,
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก'
          })
          .then(result => {
            if (result.value == true) {
              this.submitData()
            }
          })
      }
    },
    async submitData() {
      var isValid = await this.$refs.observer.validate()
      if (isValid) {
        var data = {
          tags: null,
          code: null,
          dpType: '',
          userid: this.memberData.userid,
          projectid: this.selectedProject.id,
          memberid: this.memberData.memberid,
          formid: this.TypeProjectdata[0].steps[0].customform, // id ของ form ที่กรอ
          formdata: JSON.stringify({
            ...this.formdata,
            projectname: this.selectedProject.projectname,
            memberid: this.memberData.memberid,
            profiledata: this.memberData,
            formname: this.form.formname,
            timestamp: moment().format('YYYY-MM-DD HH:mm')
          }),
          current_stepid:
            this.TypeProjectdata[0].steps[0] != undefined
              ? this.TypeProjectdata[0].steps[0].id
              : null, // stepid ของ form ถัดไป
          next_stepid:
            this.TypeProjectdata[0].steps[1] != undefined
              ? this.TypeProjectdata[0].steps[1].id
              : null // stepid ของ form ถัดไป
        }

        if (data) {
          let response = await api.depaapplyprojectform(data)
          if (response.data.responsecode == 200) {

            //-- disable qr payment
            // this.checkisPadid = response.data.data[0].isPaid
            // this.dataPayment.applicantid = response.data.data[0].applicantid
            // if (!this.checkisPadid) {
            //   if (this.dataPayment.applicantfee > 0) {
            //     this.$swal
            //       .fire({
            //         type: 'success',
            //         title:
            //           '<div class="headline primary--text bold7 fs-24">ส่งแบบฟอร์มเรียบร้อย</div>',
            //         allowOutsideClick: false,
            //         html: `
            //                     <span style="color: orange; margin-top: 10px">
            //                     <span style="display: inline-block; width: 7px; height: 7px; background-color: orange; margin-right: 5px; border-radius: 10px; margin-bottom: 1px"></span>
            //                     อยู่ระหว่างการตรวจสอบ
            //                     </span>
            //                     <br>
            //                     กรุณาทำการชำระเงินเพื่อทำรายการต่อไป
            //                 `,
            //         showCancelButton: true,
            //         confirmButtonText:
            //           '<span style="font-weight: 700;font-size: 16px;color:#FFEF01">ชำระเงิน</span>',
            //         cancelButtonText:
            //           '<span style="font-weight: 700;font-size: 16px;color:#0C2F53">ภายหลัง</span>',
            //         reverseButtons: true
            //       })
            //       .then(result => {
            //         if (result.value == true) {
            //           //showing qr code
            //           this.openModalPayment = true
            //         } else if (result.dismiss == 'cancel') {
            //           this.getDataPayment()
            //           this.checkTechhunt()
            //         }
            //       })
            //   } else {
            //     this.checkTechhunt()
            //   }
            // } else {
            //   await this.$swal.fire({
            //     title: 'ส่งแบบฟอร์มไม่สำเร็จ',
            //     text: response.data.reason,
            //     icon: 'error',
            //     confirmButtonText: 'ปิด'
            //   })
            // }
            //--END Disable qr payment

            await this.$swal
              .fire({
                type: 'success',
                title: '<div class="headline primary--text bold7 fs-24">ส่งแบบฟอร์มเรียบร้อย</div>',
                confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
                allowOutsideClick: false
              })
              .then(result => {
                if (result.value) {
                  this.closemodal()
                  location.reload()
                }
              })
          }
          else {
            await this.$swal
              .fire({
                type: 'error',
                icon: 'error',
                title: '<div class="headline primary--text bold7 fs-24">ส่งแบบฟอร์มไม่สำเร็จ</div>',
                confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
                allowOutsideClick: false
              })
              .then(result => {
                if (result.value) {
                }
              })
          }
        }
      } else {
        await this.$nextTick()
        let el = document.querySelector('.v-input.error--text')

        if (!el) {
          el = document.querySelector('div.error--text')
        }

        el.scrollIntoView()
      }
    },
    async getDataPayment() {
      const data = await api.depaProjectPayment(this.dataPayment.applicantid, this.selectedIdMember)
    },
    async checkTechhunt() {
      if (this.checkPayment) {
        if (this.project.isconnecttechhunt && this.query.edit !== 'true') {
          await this.$swal
            .fire({
              title: 'ชำระเงินสำเร็จ',
              html: `
                                <div style="display: flex; align-itmes: center; justify-content: center; font-size:16px; font-weight: 500"> ${new Date().toLocaleString(
                'fr-FR'
              )} </div>
                            `,
              icon: 'success',
              confirmButtonText: 'ถัดไป'
            })
            .then(result => {
              if (result.isConfirmed) {
                this.closemodal()
                location.reload()
              }
            })
          //
          return
        } else {
          await this.$swal.fire({
            title: 'ชำระเงินสำเร็จ',
            html: `
              <div style="display: flex; align-itmes: center; justify-content: center; font-size:16px; font-weight: 500"> ${new Date().toLocaleString(
              'fr-FR'
            )} </div>
            `,
            icon: 'success',
            confirmButtonText: 'ปิด'
          })
          //this.closeForm(true)
        }
      } else {
        if (this.project.isconnecttechhunt && this.query.edit !== 'true') {
          await this.$swal
            .fire({
              title: 'ส่งแบบฟอร์มเรียบร้อย',
              html:
                "<div  style='color:#FF8A00; display: flex; align-items: center; justify-content: center; '   font-weight:600'><span style='font-size:28px; line-height: 0.5;    padding-top: 5px;    padding-right: 2px;' >•</span><span style=' font-size:'16px' >  อยู่ระหว่างการตรวจสอบ</span></div>",
              icon: 'success',
              confirmButtonText: 'ถัดไป'
            })
            .then(result => {
              if (result.isConfirmed) {
                this.closemodal()
                location.reload()
              }
            })
          //
          return
        } else {
          this.$swal
            .fire({
              type: 'success',
              title: '<div class="headline primary--text bold7 fs-24">ส่งแบบฟอร์มเรียบร้อย</div>',
              confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
              allowOutsideClick: false
            })
            .then(result => {
              if (result.value) {
                this.closemodal()
                location.reload()
              }
            })
        }
      }
    }
  },
  filters: {
    showFilename(value) {
      var result = value
      if (result) {
        result = result.split('/')
        result = result[4].substring(13)
      }
      return result
    }
  }
}
</script>
<style lang="scss" scoped>
.multiselect__tag-icon:after {
  color: #80beff !important;
}

.multiselect__tag {
  background: #0e3154 !important;
}

.has-error .multiselect .multiselect__tags {
  border: 1px solid #ff3737 !important;
}

.uploaddepa {
  padding-right: 30px !important;
}

.v-input__slot {
  background-color: transparent !important;
}

.v-label {
  z-index: 20;
}

label.unit-text,
.unit-text input {
  position: relative;
  display: block;
  padding-right: 40px !important;
  width: 260px;
  box-sizing: border-box;
}

label.unit-text::after {
  content: attr(data-unit);
  position: absolute;
  top: 6px;
  right: 10px;
  font-size: 16px;
  display: block;
  color: #bdbdbd;
  font-weight: bold;
}

.typeCard {
  border-radius: 6px;

  .typeCardHeader {
    background: #beccdb;
    border-radius: 6px 6px 0px 0px;
    height: 66px;
    color: #0c2f53;
    display: flex;
    align-items: center;
    padding: 0 24px;

    .headerNumber {
      display: flex;
      width: 26px;
      height: 26px;
      justify-content: center;
      align-items: center;
      background: transparent;
      border-radius: 50%;
      border: 2px solid #0c2f53;
    }

    .headerNumber+.headerText {
      margin-left: 14px;
    }
  }

  .typeCardBody {
    border: 1px solid #beccdb;
    border-radius: 0px 0px 6px 6px;

    .typeCardStep {
      margin: 20px 14px 20px 14px;
      padding: 20px;
      border: 1px solid #beccdb;
      border-radius: 6px;
    }
  }
}

.customCancelBtn {
  font-weight: 700;
  font-size: 16px;
  width: 142px;
  margin: 0 7px;
}

.customConfirmBtn {
  color: yellow !important;
  font-weight: 700;
  font-size: 16px;
  width: 142px;
  margin: 0 7px;
}

.dataReq {
  display: flex;
}

.dataReq::after {
  content: '*';
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/view/projectMaster/FormAddMember.vue